/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/validators.ts (Callback Profiles)
 🗓️ Created: 2025-01-15
 🧩 Description:
    Form validation functions for Callback Profiles.

────────────────────────────────────────────────────────────────*/

import { FormState } from '../types';
import type { FormErrors } from '../types/callbackProfiles.types';

export const validateForm = (formData: FormState, t: (key: string) => string): FormErrors => {
  const errors: FormErrors = {};

  if (!formData.name.trim()) {
    errors.name = t('callbackProfiles.form.errors.nameRequired');
  }

  if (Number(formData.timeoutSeconds) < 0) {
    errors.timeoutSeconds = t('callbackProfiles.form.errors.positiveNumber');
  }

  if (Number(formData.retryInterval) < 0) {
    errors.retryInterval = t('callbackProfiles.form.errors.positiveNumber');
  }

  if (Number(formData.maxAttempts) < 1) {
    errors.maxAttempts = t('callbackProfiles.form.errors.minOne');
  }

  return errors;
};

